import LanguageSelector from './LanguageSelector'
import UserMenu from './UserMenu'
import FeedbackButton from './FeedbackButton'
import { useDevMode } from '../context/DevModeContext'
import { tEn } from '../i18n/translations'
import { useLanguage } from '../context/LanguageContext'

const IS_DEV = import.meta.env.DEV

export default function Header() {
  const { t } = useLanguage()
  const { devMode, toggleDevMode } = useDevMode()

  return (
    <header className="header">
      <div className="header-content">
        <div className="app-identity"><span className="app-monogram" aria-hidden="true">ቅ</span><h1 className="header-title">
          <span className="header-geez" title={tEn('headerTitle')}>{t('headerTitle')}</span>
          <a className="header-subtitle" href="https://geezword.com">geezword.com ↗</a>
        </h1></div>
        <div className="header-actions">
          <LanguageSelector />
          <details className="account-tools"><summary aria-label={t('browseAccount')} title={t('browseAccount')}><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7"><circle cx="12" cy="8" r="3.5"/><path d="M5 21v-2a7 7 0 0 1 14 0v2"/></svg></summary><div className="account-panel">
          {IS_DEV && (
            <button
              className="dev-mode-toggle"
              onClick={toggleDevMode}
              title={devMode ? 'Switch to User mode' : 'Switch to Dev mode'}
            >
              {devMode ? 'DEV' : 'USER'}
            </button>
          )}
          <FeedbackButton />
          <UserMenu />
          </div></details>
        </div>
      </div>
    </header>
  )
}
